import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

function VerifyDevice() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('Verifying your device...');

  useEffect(() => {
    const verifyDevice = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link');
        return;
      }

      try {
        await authAPI.verifyDevice(token);
        setStatus('success');
        setMessage('Device verified successfully!');
        
        // Redirect to login or home after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (err) {
        setStatus('error');
        setMessage(
          err.response?.data?.message || 
          'Failed to verify device. The link may be invalid or expired.'
        );
      }
    };

    verifyDevice();
  }, [token, navigate]);

  return (
    <div className="verify-device-container">
      <div className="verify-device-card">
        {status === 'verifying' && (
          <>
            <div className="spinner-large"></div>
            <h2>Verifying Device</h2>
            <p>{message}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="success-icon">
              <svg 
                width="64" 
                height="64" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h2>Device Verified!</h2>
            <p>{message}</p>
            <p className="redirect-message">Redirecting to login...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="error-icon">
              <svg 
                width="64" 
                height="64" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
            </div>
            <h2>Verification Failed</h2>
            <p>{message}</p>
            <button 
              onClick={() => navigate('/login')} 
              className="btn-primary"
            >
              Return to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyDevice;
